export const CLASSES = [
  'Warrior',
  'Paladin',
  'Hunter',
  'Rogue',
  'Priest',
  'Shaman',
  'Mage',
  'Warlock',
  'Druid',
] as const;
export type PlayerClass = (typeof CLASSES)[number];

/** Blizzard playable-class ids (Game Data API) for the Classic Era classes. */
export const PLAYABLE_CLASS_IDS: Record<PlayerClass, number> = {
  Warrior: 1,
  Paladin: 2,
  Hunter: 3,
  Rogue: 4,
  Priest: 5,
  Shaman: 7,
  Mage: 8,
  Warlock: 9,
  Druid: 11,
};

export const PROFESSIONS = [
  'Alchemy',
  'Blacksmithing',
  'Enchanting',
  'Engineering',
  'Leatherworking',
  'Tailoring',
  'Cooking',
  'First Aid',
  'Fishing',
  'Mining',
  'Herbalism',
  'Skinning',
] as const;
export type Profession = (typeof PROFESSIONS)[number];

export const ITEM_QUALITY_NAMES = ['Poor', 'Common', 'Uncommon', 'Rare', 'Epic', 'Legendary', 'Artifact'] as const;
